<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>S201系統功能目錄階層維護-查詢條件</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>系統類別</td>
                  <td colspan="3">
                    <select v-model="form.DirType">
                      <option
                        v-for="(item, index) in dropDownList.DirType"
                        :value="item.mcode"
                        :key="index"
                      >
                        {{ item.mvalue }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>目錄代碼</td>
                  <td><input type="text" v-model="form.DirCode" /></td>
                </tr>
                <tr>
                  <td>目錄類名稱</td>
                  <td>
                    <input type="text" v-model="form.DirName" />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="doQuery()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="新增"
                          @click="btnAdd()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th colspan="2">操作</th>
                    <th>系統類別</th>
                    <th>目錄代碼</th>
                    <th>目錄名稱</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="編"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="btnEdit(data)"
                      />
                    </td>
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="刪"
                        data-toggle="modal"
                        @click="btnDelete(data)"
                      />
                    </td>
                    <td>{{ data.diR_TYPE_MVALUE }}</td>
                    <td>{{ data.diR_CODE }}</td>
                    <td>{{ data.diR_NAME }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <CyFooter />

    <AddModal
      v-model="addModal.show"
      :title="addModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>系統類別</td>
                <td colspan="3">
                  <select v-model="addModal.form.DirType">
                    <option
                      v-for="(item, index) in addModal.dropDownList.DirType"
                      :value="item.mcode"
                      :key="index"
                    >
                      {{ item.mvalue }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>目錄代碼</td>
                <td><input type="text" v-model="addModal.form.DirCode" /></td>
              </tr>
              <tr>
                <td>目錄類名稱</td>
                <td>
                  <input type="text" v-model="addModal.form.DirName" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="addModalSave()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnAddModalClear()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </AddModal>

    <AddDetailModal
      v-model="addDetailModal.show"
      :title="addDetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>系統類別</td>
                <td colspan="3">
                  <select v-model="addDetailModal.form.DirType" disabled>
                    <option
                      v-for="(item, index) in addDetailModal.dropDownList
                        .DirType"
                      :value="item.mcode"
                      :key="index"
                    >
                      {{ item.mvalue }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>目錄代碼</td>
                <td>
                  <input
                    type="text"
                    v-model="addDetailModal.form.DirCode"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>目錄類名稱</td>
                <td>
                  <input type="text" v-model="addDetailModal.form.DirName" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="addDetailModalSave()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="新增子目錄"
                        @click="addDetailModalCreate('', 'I')"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
        <!-- 查詢結果開始-->
        <div class="information">
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th colspan="2">操作</th>
                    <th>子目錄代碼</th>
                    <th>子目錄名稱</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in addDetailModal.grid" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="編"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="addDetailModalCreate(data, 'U')"
                      />
                    </td>
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="刪"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="btnAddDetailModalDelete(data)"
                      />
                    </td>
                    <td>{{ data.layeR_CODE }}</td>
                    <td>{{ data.layeR_NAME }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
    </AddDetailModal>

    <AddDetailSonModal
      v-model="addDetailSonModal.show"
      :title="addDetailSonModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>目錄代碼</td>
                <td>
                  <input
                    type="text"
                    disabled="disabled"
                    v-model="addDetailSonModal.form.DirCode"
                  />
                </td>
              </tr>
              <tr>
                <td>目錄類名稱</td>
                <td>
                  <input
                    type="text"
                    disabled="disabled"
                    v-model="addDetailSonModal.form.DirName"
                  />
                </td>
              </tr>
              <tr>
                <td>子目錄代碼</td>
                <td>
                  <input
                    type="text"
                    v-model="addDetailSonModal.form.LayerCode"
                  />
                </td>
              </tr>
              <tr>
                <td>子目錄名稱</td>
                <td>
                  <input
                    type="text"
                    v-model="addDetailSonModal.form.LayerName"
                  />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="addDetailSonModalSave()"
                      />
                      <!-- <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnAddDetailSonModalClear()"
                      />-->
                    </span>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </AddDetailSonModal>

    <Alert v-model="Alert.show" :title="Alert.title" :ServiceUnit="pageData.ServiceUnit">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <AlertDelete v-model="AlertDelete.show" :title="AlertDelete.title" :ServiceUnit="pageData.ServiceUnit">
      <div style="text-align: center">
        <div>是否確定刪除</div>
        <div>
          <button class="btn" @click="AlertDelete.BtnYesConfirm">是</button>
          <button class="btn" @click="AlertDelete.BtnNoConfirm">否</button>
        </div>
      </div>
    </AlertDelete>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { getMenuIndex } from "@/config/util.js";
import {
  S201_GetDirTypeOption,
  S201_QueryDirdirectory,
  S201_AddSaveDirdirectory,
  S201_RemoveDirdirectory,
  S201_EditSaveDirdirectory,
  S201_QueryDirLayer,
  S201_AddSaveDirLayer,
  S201_RemoveDirLayer,
  S201_EditSaveDirLayer,
} from "@/service/api.js";
export default {
  name: "S201",
  data: function () {
    return {
      pageData: {
        MenuIndex: 3,
        PrgName: "S201",
        ServiceUnit: "CY",
        isForceLoginOut : true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      grid: [],
      form: {
        DirType: "",
        DirCode: "",
        DirName: "",
      },
      addModal: {
        show: false,
        title: "S201系統功能目錄階層維護-編輯",
        dropDownList: {
          DirType: [],
        },
        form: {
          PKNO: "",
          DirType: "",
          DirCode: "",
          DirName: "",
        },
      },
      addDetailModal: {
        show: false,
        title: "S201系統功能目錄階層維護-編輯",
        dropDownList: {
          DirType: [],
        },
        grid: [],
        form: {
          PKNO: "",
          DirType: "",
          DirCode: "",
          DirName: "",
        },
      },
      addDetailSonModal: {
        show: false,
        title: "S201系統功能目錄階層維護-編輯",
        form: {
          Type: "",
          PKNO: "",
          DirCode: "",
          DirName: "",
          LayerCode: "",
          LayerName: "",
        },
      },
      dropDownList: {
        DirType: [],
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      AlertDelete: {
        show: false,
        title: "系統訊息",
        BtnYesConfirm: function () {
          this.show = false;
        },
        BtnNoConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Alert: VueModal,
    AlertDelete: VueModal,
    AddModal: VueModal,
    AddDetailModal: VueModal,
    AddDetailSonModal: VueModal,
  },
  methods: {
    getSearchDirtype: function () {
      const self = this;
      S201_GetDirTypeOption({ ServiceUnit: self.pageData.ServiceUnit }).then((rData) => {
        self.dropDownList.DirType = rData.returnObject;
      });
    },
    doQuery: function () {
      const self = this;
      var msg = [];
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        DIR_TYPE: self.form.DirType,
        DIR_CODE: self.form.DirCode,
        DIR_NAME: self.form.DirName,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S201_QueryDirdirectory(postData).then((rData) => {
        if (rData.returnObject.length != 0) {
          self.grid = rData.returnObject;
        } else {
          self.grid = [];
          self.Alert.show = true;
          msg.push('查無資料');
          self.Alert.title = "系統訊息";
          self.Alert.txt = msg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    btnAdd: function () {
      const self = this;
      self.btnAddModalClear();
      self.addModal.dropDownList.DirType = self.dropDownList.DirType;
      self.addModal.show = true;
    },
    btnClear: function () {
      const self = this;
      self.form.DirType = "";
      self.form.DirCode = "";
      self.form.DirName = "";
    },
    btnEdit: function (data) {
      const self = this;
      //var type = self.dropDownList.DirType.filter(x=>x.mvalue == data.diR_TYPE_MVALUE);
      self.addDetailModal.dropDownList.DirType = self.dropDownList.DirType;
      self.addDetailModal.form.DirType = self.dropDownList.DirType.filter(
        (x) => x.mvalue == data.diR_TYPE_MVALUE
      )[0].mcode;
      self.addDetailModal.form.DirCode = data.diR_CODE;
      self.addDetailModal.form.DirName = data.diR_NAME;
      self.addDetailModal.form.PKNO = data.pkno;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        DIR_CODE: data.diR_CODE,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "編",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      self.addDetailModal.show = false;
      S201_QueryDirLayer(postData).then((rData) => {
        self.addDetailModal.grid = rData.returnObject;
        self.addDetailModal.show = true;
      });
    },
    btnDelete: function (data) {
      const self = this;
      self.AlertDelete.show = true;
      self.AlertDelete.BtnYesConfirm = () => {
        var msg = [];
        let postData = {
          ServiceUnit: self.pageData.ServiceUnit,
          DIR_CODE: data.diR_CODE,
          LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        };
        S201_RemoveDirdirectory(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            msg.push("刪除成功");
            self.Alert.txt = msg;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.form.Selected = [];
              self.doQuery();
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            msg.push("刪除失敗");
            self.Alert.txt = msg;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
        self.AlertDelete.show = false;
      };
      self.AlertDelete.BtnNoConfirm = () => {
        self.AlertDelete.show = false;
      };
    },
    addModalSave: function (data) {
      const self = this;
      let errorMsg = [];
      if (self.addModal.form.DirType == "") {
        errorMsg.push("請輸入系統類別");
      }

      if (self.addModal.form.DirCode == "") {
        errorMsg.push("請輸入目錄代碼");
      }

      if (self.addModal.form.DirName == "") {
        errorMsg.push("請輸入目錄類名稱");
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }

      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        DIR_TYPE: self.addModal.form.DirType,
        DIR_CODE: self.addModal.form.DirCode,
        DIR_NAME: self.addModal.form.DirName,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "新增系統目錄設定檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S201_AddSaveDirdirectory(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.form.Selected = [];
            self.addModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    btnAddModalClear: function (data) {
      const self = this;
      self.addModal.form.DirType = "";
      self.addModal.form.DirCode = "";
      self.addModal.form.DirName = "";
    },
    addDetailModalSave: function () {
      const self = this;

      let errorMsg = [];
      if (self.addDetailModal.form.DirName == "") {
        errorMsg.push("請輸入目錄類名稱");
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return;
      }

      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        PKNO: self.addDetailModal.form.PKNO,
        DIR_NAME: self.addDetailModal.form.DirName,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "修改系統目錄設定檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S201_EditSaveDirdirectory(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          errorMsg.push("存檔成功");
          self.Alert.txt = errorMsg;
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.form.Selected = [];
            self.addModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          errorMsg.push("存檔失敗");
          self.Alert.txt = errorMsg;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    addDetailModalCreate: function (data, type) {
      const self = this;
      self.addDetailSonModal.form.Type = type;
      self.addDetailSonModal.form.DirCode = self.addDetailModal.form.DirCode;
      self.addDetailSonModal.form.DirName = self.addDetailModal.form.DirName;

      if (type == "U") {
        self.addDetailSonModal.form.PKNO = data.pkno;
        self.addDetailSonModal.form.LayerCode = data.layeR_CODE;
        self.addDetailSonModal.form.LayerName = data.layeR_NAME;
      } else {
        self.addDetailSonModal.form.LayerCode = "";
        self.addDetailSonModal.form.LayerName = "";
      }

      self.addDetailSonModal.show = true;
    },
    btnAddDetailModalDelete: function (data) {
      const self = this;
      self.AlertDelete.show = true;
      self.AlertDelete.BtnYesConfirm = () => {
        let errorMsg = [];
        let postData = {
          ServiceUnit: self.pageData.ServiceUnit,
          PKNO: data.pkno,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "刪除目錄階層檔",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S201_RemoveDirLayer(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            errorMsg.push("刪除成功");
            self.Alert.txt = errorMsg;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.form.Selected = [];
              self.addModal.show = false;
              let postData = {
                pkno: self.addDetailModal.form.PKNO,
                diR_TYPE_MVALUE: self.addDetailModal.dropDownList.DirType.filter(
                  (x) => x.mcode == self.addDetailModal.form.DirType
                )[0].mvalue,
                diR_CODE: self.addDetailModal.form.DirCode,
                diR_NAME: self.addDetailModal.form.DirName,
              };
              self.btnEdit(postData);
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            errorMsg.push("刪除失敗");
            self.Alert.txt = errorMsg;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
        self.AlertDelete.show = false;
      };
      self.AlertDelete.BtnNoConfirm = () => {
        self.AlertDelete.show = false;
      };
    },
    btnAddDetailModalClear: function () {
      const self = this;
      self.addDetailModal.form.DirName = "";
    },
    addDetailSonModalSave: function () {
      const self = this;

      let errorMsg = [];
      if (self.addDetailSonModal.form.LayerCode == "") {
        errorMsg.push("請輸入子目錄代碼");
      }

      if (self.addDetailSonModal.form.LayerName == "") {
        errorMsg.push("請輸入子目錄名稱");
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return;
      }

      if (self.addDetailSonModal.form.Type == "I") {
        let postData = {
          ServiceUnit: self.pageData.ServiceUnit,
          DIR_CODE: self.addDetailSonModal.form.DirCode,
          LAYER_CODE: self.addDetailSonModal.form.LayerCode,
          LAYER_NAME: self.addDetailSonModal.form.LayerName,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "新增目錄階層檔",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S201_AddSaveDirLayer(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.form.Selected = [];
              self.addDetailSonModal.show = false;
              let postData = {
                pkno: self.addDetailModal.form.PKNO,
                diR_TYPE_MVALUE: self.addDetailModal.dropDownList.DirType.filter(
                  (x) => x.mcode == self.addDetailModal.form.DirType
                )[0].mvalue,
                diR_CODE: self.addDetailModal.form.DirCode,
                diR_NAME: self.addDetailModal.form.DirName,
              };
              self.btnEdit(postData);
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }

      if (self.addDetailSonModal.form.Type == "U") {
        let postData1 = {
          ServiceUnit: self.pageData.ServiceUnit,
          PKNO: self.addDetailSonModal.form.PKNO,
          LAYER_CODE: self.addDetailSonModal.form.LayerCode,
          LAYER_NAME: self.addDetailSonModal.form.LayerName,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "修改目錄階層檔",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S201_EditSaveDirLayer(postData1).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.form.Selected = [];
              self.addDetailSonModal.show = false;
              let postData = {
                pkno: self.addDetailModal.form.PKNO,
                diR_TYPE_MVALUE: self.addDetailModal.dropDownList.DirType.filter(
                  (x) => x.mcode == self.addDetailModal.form.DirType
                )[0].mvalue,
                diR_CODE: self.addDetailModal.form.DirCode,
                diR_NAME: self.addDetailModal.form.DirName,
              };
              self.btnEdit(postData);
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
    btnAddDetailSonModalClear: function () {
      const self = this;
      self.addDetailSonModal.form.LayerCode = "";
      self.addDetailSonModal.form.LayerName = "";
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    if (self.pageData.MenuIndex === null) {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.getSearchDirtype();
    //self.doQuery();
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
